import { MenuItem, TextField } from '@mui/material';
import type { FieldRendererProps } from '../types';
import type { FieldDefinition } from '../types';

interface SelectInputProps extends FieldRendererProps {
  definition: FieldDefinition;
}

export function SelectInput({
  name,
  label,
  required,
  value,
  error,
  onChange,
  definition
}: SelectInputProps) {
  const options = definition.enumValues ?? [];
  return (
    <TextField
      select
      name={name}
      label={label}
      required={required}
      value={(value as string | null) ?? ''}
      onChange={(e) => onChange(e.target.value)}
      error={!!error}
      helperText={error ?? undefined}
    >
      {options.length === 0 && (
        <MenuItem value="" disabled>
          No options configured for this field
        </MenuItem>
      )}
      {options.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </TextField>
  );
}
